
  @if (userProfile) {
    <lib-sidebar
      [sidebarConfig]="sidebarConfig"
      [sidebarItems]="sidebarItems"
      [iconHeight]="20"
      [iconWidth]="20"
      [redirectToRoute]="redirectToRoute"
      [environment]="env"
      [application]="application"
      [theme$]="theme$"
      [userProfile]="userProfile"
      (whatsNewClicked)="handleWhatsNewClicked()">
    </lib-sidebar>
  }
